var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable i18next/no-literal-string -- Dev tools don't use translations */
import { Box, Typography } from '@lucidlink/uicore';
import { useShownLogs } from '../../../query-hooks';
import { LogFormat, logToString } from '../../../services';
import { LOG_LEVEL_CONFIG } from '../Logging.constants';
const MAX_NUMBER_OF_LOGS_SHOWN = 100;
export const LogConsole = ({ disabled = false, logs }) => {
    _react_refresh_temp_2();
    const { query: { data: shownLogs = [] }, } = useShownLogs(logs, MAX_NUMBER_OF_LOGS_SHOWN);
    return (_jsx(Box, { kind: disabled ? 'flex' : 'level3', orientation: "vertical", padding: "xs", children: disabled ? (_jsx(Typography, { color: "default", kind: "p", children: "Link at least 1 filespace in order to view the logs..." })) : (shownLogs.map((log, index) => {
            const message = logToString(log, LogFormat.Pretty);
            const color = LOG_LEVEL_CONFIG[log.level].color;
            return (_jsx(Typography, { color: color, kind: "p", children: message }, index));
        })) }));
};
_react_refresh_temp_1 = LogConsole;
$RefreshReg$(_react_refresh_temp_1, "LogConsole");
_react_refresh_temp_2(LogConsole, "wXZWBv5fzuqg/9W/IWf7IiZdIWU=", false, () => [useShownLogs]);
